import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { LayoutColors } from '@src/core/theme';
import { device } from '@src/common/breakpoints';
import ArrowDown from '@src/icons/arrow-down-icon.svg';

type Props = {
  children: ReactNode;
  title: ReactNode | string;
  onClick?: () => void;
  isExpanded?: boolean;
  disabled?: boolean;
};

type ContentWrapperProps = {
  isExpanded: boolean;
};

const Collapse = (props: Props) => {
  const { children, title, isExpanded = false, onClick, disabled = false } = props;

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <Container aria-label='collapse container' aria-disabled={disabled} disabled={disabled}>
      <Header aria-disabled={disabled} disabled={disabled} onClick={handleClick}>
        {title}
        <ArrowDown />
      </Header>
      <ContentWrapper isExpanded={isExpanded}>
        <Content aria-label='content'>{children}</Content>
      </ContentWrapper>
    </Container>
  );
};

export default Collapse;

const Container = styled.article<{ disabled: boolean }>`
  width: 100%;
  height: max-content;
  max-height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${LayoutColors.gray};
  border-radius: 4px;

  ${({ disabled }) => (disabled ? 'cursor: not-allowed !important;' : '')}

  ${device.mediumTablet} {
    max-height: 736px;
  }
`;

const Header = styled.div<{ disabled: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border: none;
  background: transparent;
  cursor: pointer !important;
  padding: 0;

  ${({ disabled }) => (disabled ? 'pointer-events: none; ' : '')}

  ${device.mediumTablet} {
    cursor: default;
    padding: 16px 0;
  }
`;

const Content = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${device.mediumTablet} {
    max-height: 590px;
    padding: 0px 8px 0 0;
  }
`;

const ContentWrapper = styled.div<ContentWrapperProps>`
  width: 100%;
  opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
  height: ${({ isExpanded }) => (isExpanded ? '600px' : '0px')};
  pointer-events: ${({ isExpanded }) => (isExpanded ? 'auto' : 'none')};

  transition: height 0.3s ease-in-out, opacity 0.3s ease-in-out;
`;
